module.exports = __webpack_public_path__ + "static/media/malaria.7c918dee.jpg";